import { useQuery } from "@tanstack/react-query";

import { client } from "@krea/customer-features/graphql";
import { CMS_SITE_SETTINGS_FRAGMENT } from "@krea/customer-features/graphql/cms-site-settings/cms-site-settings.fragment";
import { settings } from "@krea/customer-features/settings";
import { CMS_SITE_SETTINGS_STORE_KEY } from "@krea/customer-features/store/queryClient";
import type {
  IReviewProviderScore,
  ISiteSettings,
} from "@krea/customer-features/types/cmsSiteSettings";
import type { ReviewProviderEnum } from "@krea/customer-features/types/reviewProvider";

export const useGetCmsSiteSettings = () => {
  const siteHostnameObject = new URL(settings.countryWebsiteUrl);
  const siteHostname =
    siteHostnameObject.hostname +
    (siteHostnameObject.port ? `:${siteHostnameObject.port}` : "");

  return useQuery<ISiteSettings>({
    queryKey: [CMS_SITE_SETTINGS_STORE_KEY, siteHostname],
    queryFn: async () => {
      const query = `
      query GetCmsSiteSettings($siteHostname: String!) {
        cmsSiteSettings(siteHostname: $siteHostname) {
          ...CMSSiteSettingsFragment
        }
      }
      ${CMS_SITE_SETTINGS_FRAGMENT}
      `;

      const response = await client.request<{ cmsSiteSettings: ISiteSettings }>(
        query,
        { siteHostname },
      );

      return response.cmsSiteSettings;
    },
    staleTime: Number.POSITIVE_INFINITY,
  });
};

export const useReviewProviderScoresList = (): IReviewProviderScore[] => {
  const { data } = useGetCmsSiteSettings();
  return data?.reviewProviderScores ?? [];
};

export const useGetReviewProviderScores = (
  providerName: ReviewProviderEnum,
) => {
  const list = useReviewProviderScoresList();
  return list.find((p) => p.provider === providerName) ?? null;
};
